<template>
  <div class="termsAgreement">
    <!-- <div class="thirdPartyLogin">
      <img
        src="../../assets/img/registrationLogin/wx_logo.png"
        alt="微信登录"
        class="wx_logo thirdParty"
      >
      <img
        src="../../assets/img/registrationLogin/qq_logo.png"
        alt="QQ登录"
        class="qq_logo thirdParty"
      >
      <img
        src="../../assets/img/registrationLogin/wb_logo.png"
        alt="微博登录"
        class="wb_logo thirdParty"
      >
    </div> -->
    <div class="termsAgrDesc">
      <div @click="change">
        <img
          v-show="!checked"
          src="../../assets/img/registrationLogin/login-check.png"
          alt=""
          srcset=""
        />
        <img
          v-show="checked"
          src="../../assets/img/registrationLogin/login-checked.png"
          alt=""
          srcset=""
        />
      </div>
      我已阅读并同意
       <router-link to="/registeredapp">用户协议</router-link>
      <!-- <a href="http://mobile.iqihang.com/ark/registeredapp">服务条款</a> -->
      和
      <a href="https://mobile.iqihang.com/zt/privacy_app/index.html">隐私政策</a>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      checked: false,
    };
  },
  methods: {
    change() {
      this.checked = !this.checked;
      this.$emit('receivePraive', this.checked);
    },
  },
  mounted() {
    this.$emit('receivePraive', this.checked);
  },
};
</script>
<style lang="scss" scoped>
.termsAgreement {
  width: 100%;
  text-align: center;
  // position: fixed;
  // bottom: 152.17px;

  .thirdPartyLogin {
    display: flex;
    padding-bottom: 43px;
    .wx_logo {
      margin-left: 159px;
    }
    .thirdParty {
      width: 91px;
      height: 91px;
      margin-right: 80px;
    }
  }

  .termsAgrDesc {
    display: flex;
    justify-content: center;
    color: #333;
    font-weight: 400;
    font-size: 25px;
    line-height: 36px;
    img {
      width: 32px;
      height: 32px;
      margin: 0 10px 0 0;
    }
    a {
      color: #ff6c02;
      text-decoration: underline;
    }
  }
}
</style>
